$bog_gamengine_demo_room $mol_page
	title \Комната
	tools /
		<= Wireframe $mol_check_box
			title \Каркас
			checked? <=> wireframe?
		<= Shine $mol_check_box
			title \Блики
			checked? <=> shine? false
		<= Glow $mol_check_box
			title \Свечение
			checked? <=> glow? false
		<= Shadows $mol_check_box
			title \Тени
			checked? <=> shadows?
		<= Fog_check $mol_check_box
			title \Туман
			checked? <=> fogged? false
		<= Arm_check $mol_check_box
			title \Рука
			checked? <=> arm_shown? false
		<= Pause $mol_check_box
			title \Пауза
			checked? <=> paused?
		<= Screen_switch $mol_check_box
			title \Кнопки
			checked? <=> screen_shown? false
		<= Full $mol_check_box
			title \Во весь экран
			checked? <=> fullscreen? false
		<= Profile $mol_check_box
			title \Профиль
			checked? <=> profile? false
	body /
		<= Draw $bog_gamengine_draw
			scene <= Scene
			cam <= Walker
			wireframe? => wireframe?
			shadows? => shadows?
			fog <= fog Float32Array
			fog_color <= fog_color Float32Array
			passes <= passes /
			stat => stat
			report => report
			event *
				pointerdown? <=> canvas_down? null
		<= Screen $bog_gamengine_input_screen
			shown? <=> screen_shown? false
			bind *
				left / \x-
				right / \x+
				forward / \y+
				back / \y-
			actions /
				\turn_left
				\turn_right
			titles *
				turn_left \⟲
				turn_right \⟳
	foot <= foot_rows /
		<= Stat $mol_view
			sub / <= stat
		<= Walker_stat $mol_view
			sub / <= walker_stat \
		<= Pillar_stat $mol_view
			sub / <= pillar_stat \
		<= Arm_stat $mol_view
			sub / <= arm_stat \
		<= Light_stat $mol_view
			sub / <= light_stat \
	Tone $bog_gamengine_shader_post_tone
	Vignette $bog_gamengine_shader_post_vignette
	Bloom $bog_gamengine_shader_post_bloom
	Report $mol_view
		sub /
			<= Report_tick $mol_labeler
				title \Тик
				content / <= report_tick \
			<= Report_fill $mol_labeler
				title \Заливка
				content / <= report_fill \
			<= Report_shadow $mol_labeler
				title \Тени
				content / <= report_shadow \
			<= Report_main $mol_labeler
				title \Проход
				content / <= report_main \
			<= Report_post $mol_labeler
				title \Пост
				content / <= report_post \
			<= Report_batches $mol_labeler
				title \Батчи
				content / <= report_batches \
			<= Report_instances $mol_labeler
				title \Инстансы
				content / <= report_instances \
			<= Report_draws $mol_labeler
				title \Вызовы
				content / <= report_draws \
			<= Report_triangles $mol_labeler
				title \Треугольники
				content / <= report_triangles \
			<= Report_bytes $mol_labeler
				title \Память
				content / <= report_bytes \
	Screen_api $bog_gamengine_screen
		target <= screen_target Element
	Input $bog_gamengine_input
		key <= Key
		screen <= Screen
	Key $bog_gamengine_key
		bind *
			forward / \W
			back / \S
			left / \A
			right / \D
			turn_left / \Q
			turn_right / \E
	map \
		\############
		\#..........#
		\#..........#
		\#.......#..#
		\#...#......#
		\#..........#
		\#..........#
		\#..........#
		\############
	Tile $bog_gamengine_phys_tile
		map <= map
		plane \xz
	Atlas $bog_gamengine_atlas
		uris /
			\bog/gamengine/demo/atlas/wall.png
			\bog/gamengine/demo/atlas/floor.png
		size 64
	Clock $bog_gamengine_clock
		paused? => paused?
	Scene $bog_gamengine_scene
		clock <= Clock
		input <= Input
		kids <= nodes /
		batches /
			<= Wall_batch $bog_gamengine_batch
				shader <= Solid $bog_gamengine_shader_solid
				shape <= Box $bog_gamengine_shape_box
				atlas <= Atlas
				nodes <= walls /
			<= Floor_batch $bog_gamengine_batch
				shader <= Solid
				shape <= Plane $bog_gamengine_shape_plane
					tile <= floor_tile Float32Array
				atlas <= Atlas
				nodes / <= Floor
			<= Pillar_batch $bog_gamengine_batch
				shader <= Solid
				shape <= Pillar_shape $bog_gamengine_shape_gltf
					data <= pillar_data ArrayBuffer
				atlas <= Atlas
				nodes / <= Pillar
			<= Arm_batch $bog_gamengine_batch
				shader <= Skin $bog_gamengine_shader_skin
				shape <= Arm_shape $bog_gamengine_shape_gltf
					data <= arm_data ArrayBuffer
				atlas <= Atlas
				nodes <= arm_nodes /
	Arm $bog_gamengine_mesh_skin
		skin <= Arm_skin $bog_gamengine_skin
			shape <= Arm_shape
			clip \wave
		atlas <= Atlas
		frame \wall
		pos <= arm_pos Float32Array
	Wall* $bog_gamengine_mesh
		shape <= Box
		atlas <= Atlas
		frame \wall
		pos <= wall_pos* Float32Array
		material <= wall_material Float32Array
	Floor $bog_gamengine_mesh
		shape <= Plane
		atlas <= Atlas
		frame \floor
		pos <= floor_pos Float32Array
		size <= floor_size Float32Array
	Pillar $bog_gamengine_mesh
		shape <= Pillar_shape
		atlas <= Atlas
		frame \wall
		pos <= pillar_pos Float32Array
	Walker $bog_gamengine_demo_room_walker
		input <= Input
		screen <= Screen_api
		tile <= Tile
		pos? <=> walker_pos? Float32Array
		rot? <=> walker_rot? Float32Array
	Sun $bog_gamengine_light
		kind \sun
		rot <= sun_rot Float32Array
		power 1
	Light_warm $bog_gamengine_light
		kind \point
		pos <= light_warm_pos Float32Array
		color <= light_warm_color Float32Array
		power 1.2
		range 4
	Light_cold $bog_gamengine_light
		kind \point
		pos <= light_cold_pos Float32Array
		color <= light_cold_color Float32Array
		power 1.2
		range 4
	Light_torch $bog_gamengine_light
		kind \spot
		parent <= Walker
		rot <= torch_rot Float32Array
		power 2
		range 10
		angle 0.6
